import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'

import Icon from '../../../../../../../../../components/Icon'
import ButtonIcon from '../../../../../../../../../features/components/Buttons/ButtonIcon'

import { useAddProduct } from '../../../useAddProduct'
import { useDisableProductsActions } from '../../../useDisableProductsActions'

import { ReactComponent as PencilIcon } from '../../../../../../../../../assets/icons/pencil.svg'
import { ReactComponent as CheckmarkIcon } from '../../../../../../../../../assets/icons/checked-circle.svg'
import { ReactComponent as CloseIcon } from '../../../../../../../../../assets/icons/close-circle-2.svg'
import { ReactComponent as DeleteIcon } from '../../../../../../../../../assets/icons/trash.svg'

import { PRODUCT_PERIODS_DATES, MEDIA_PRODUCTS } from '../../../../../fields'

import useStyles from './styles'

const ActionsCell = ({
  formik,
  productIndex,
  productValues,
  editProductId,
  allowAutoSave,
  handleDeleteProduct,
  handleProductEdit
}) => {
  const classes = useStyles()
  const { setFieldValue } = formik

  const productPath = `${MEDIA_PRODUCTS}[${productIndex}]`
  // set productValues as default values to avoid case when newly product is selected and there is no data yet
  const [initialValues, setInitialValues] = useState(productValues)

  const disableProductActions = useDisableProductsActions({ products: formik.values[MEDIA_PRODUCTS] })
  const { handleSaveProduct } = useAddProduct({ allowAutoSave, productPath, formik, handleProductEdit })

  const productId = productValues.id
  const isEditMode = editProductId === productId

  const handleStartEditProduct = useCallback(() => {
    // save the values before edit start, to be able to reset on these
    setInitialValues(productValues)
    handleProductEdit(productId)
  }, [productValues, handleProductEdit, productId])

  const handleResetProduct = useCallback(() => {
    setFieldValue(productPath, initialValues)

    const hasPeriods = initialValues[PRODUCT_PERIODS_DATES].length > 0
    if (!hasPeriods) {
      // we can't keep empty product, so delete it
      handleDeleteProduct(productId)
    }
    // turn off edit mode
    handleProductEdit(null)
  }, [setFieldValue, productPath, initialValues, handleProductEdit, handleDeleteProduct, productId])

  if (!productValues.data) {
    // don't show edit mode if product wasn't selected
    return (
      <ButtonIcon className={classes.smallButton} Icon={DeleteIcon} onClick={() => handleDeleteProduct(productId)} />
    )
  }

  if (!isEditMode) {
    return (
      <div className={classes.buttonsContainer}>
        <ButtonIcon
          disabled={disableProductActions}
          className={classes.smallButton}
          Icon={PencilIcon}
          onClick={handleStartEditProduct}
        />
        <ButtonIcon
          disabled={disableProductActions}
          className={classes.smallButton}
          Icon={DeleteIcon}
          onClick={() => handleDeleteProduct(productId)}
        />
      </div>
    )
  }

  return (
    <div className={classes.buttonsContainer}>
      <div className={classes.bigButton} onClick={handleResetProduct}>
        <Icon>
          <CloseIcon />
        </Icon>
      </div>
      <div className={classes.bigButton} onClick={handleSaveProduct}>
        <Icon>
          <CheckmarkIcon />
        </Icon>
      </div>
    </div>
  )
}

ActionsCell.propTypes = {
  formik: PropTypes.object.isRequired,
  productIndex: PropTypes.number.isRequired,
  productValues: PropTypes.object.isRequired,
  allowAutoSave: PropTypes.bool.isRequired,
  editProductId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleDeleteProduct: PropTypes.func.isRequired,
  handleProductEdit: PropTypes.func.isRequired
}

export default ActionsCell
